export const SET_MOBILE_DETAILS_VIEW = "SET_MOBILE_DETAILS_VIEW";
export const SET_HAS_SUBLEAGUES = "SET_HAS_SUBLEAGUES";

export const setGameDetailsView = (isVisible) => ({
  type: SET_MOBILE_DETAILS_VIEW,
  payload: {
    gameDetailsVisible: isVisible,
  },
});

export const setHasSubleagues = (hasSubleagues) => ({
  type: SET_HAS_SUBLEAGUES,
  payload: {
    hasSubleagues,
  },
});
